// extracted by css-extract-rspack-plugin
export default {"title":"JDyIhjIbYKoIbi3t","titleSize-lg":"g_bihxjLil8js1Nj","titleSize-xl":"hO5qt_9ogYZRCqSB","titleSize-md":"i9IEyiqm_8QRSJlf","titleSize-sm":"mpupx0wl1bMl6uBu"};